<template>
  <div>
    <!-- 个人中心 -->
    <Personal />
  </div>
</template>

<script>
import Personal from '../components/Personal.vue'
export default {
  components: {
    Personal
  },
  methods: {

  }
}
</script>

<style>
</style>